import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
const COLORS = {
  IN_STOCK: 'green',
  UNAVAILABLE: 'red',
  SOON: 'orange',
  MONTH: 'orange',
  WEEK: 'orange',
  LIMITED: 'orange',
  STORE_ONLY: 'black',
  DELETE: 'white',
  default: 'black'
};
export default {
  name: 'ProductStock',
  props: {
    stock: {
      type: Object,

      default() {
        return {};
      }

    },
    showOnlyInStock: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    currentStockTemporary() {
      if (this.stock.status === 'STORE_ONLY') {
        switch (this.locale.iso) {
          case 'en-UK':
            return 'Available for sale soon';

          case 'pt-PT':
            return 'Prevemente disponível';

          case 'es-ES':
            return 'Pronto disponible';

          case 'dk-DK':
            return 'Available for sale soon';

          case 'de-AT':
            return 'Bald erhältlich';

          case 'nl-NL':
            return 'Binnenkort beschikbaar';

          default:
            return this.stock.message;
        }
      }

      return this.stock.message || "".concat(this.$t('IN_STOCK'));
    },

    currentStock() {
      return this.stock.message || "".concat(this.$t('IN_STOCK'));
    },

    color() {
      return COLORS[this.stock.status] || COLORS.default;
    }

  })
};